import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { FlagColor } from "@multiweb/types/react";

export type BackgroundColorWrapperProps = {
    /** Obsah pro vložení do komponenty. */
    children: ReactNode;
    /** Název barvy pozadí typu FlagColor. */
    color: FlagColor;
};

const classNames = bemClassNames("background-color-wrapper-component");

/** Komponenta, která na základě obdržené barvy pozadí obarví obsah, který je do ní vložen. */
export const BackgroundColorWrapper: FunctionComponent<BackgroundColorWrapperProps> = ({ children, color }) => {
    return (
        <div className={classNames()} data-color={color}>
            {children}
        </div>
    );
};
